export default "/images/c347de10aa326ca8c0b1ac670a23fadc.avif";